var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 153,
    viewBox: "0 0 138 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28544_29783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3405 64.5497C44.3405 64.5497 32.6565 61.8281 28.4923 51.7322C24.0224 55.1335 20.5813 57.9772 20.5813 57.9772C20.5813 57.9772 24.1128 64.5513 34.9927 68.9526C38.0257 67.4125 44.3405 64.5497 44.3405 64.5497Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.831 41.067C115.831 41.067 122.581 31.1511 118.807 20.9034C124.395 20.3777 128.856 20.144 128.856 20.144C128.856 20.144 130.711 27.3683 125.689 37.9733C122.411 38.8985 115.829 41.059 115.829 41.059L115.831 41.067Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1507 87.7098C27.1507 87.7098 30.5904 84.858 35.0616 81.4648C35.9371 83.5765 37.134 85.3653 38.4949 86.8804L33.1424 93.9988C28.7676 90.706 27.1519 87.7179 27.1519 87.7179L27.1507 87.7098Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8914 19.504C43.0056 25.2026 50.3063 26.9059 50.3063 26.9059C50.3063 26.9059 43.9928 29.7768 40.9586 31.3088C37.4109 29.8707 34.655 28.2097 32.5376 26.6144L37.8901 19.4959L37.8914 19.504Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9142 11.6101L78.7238 10.3251C78.6097 12.5583 78.8822 14.6733 79.3007 16.5588L71.4437 17.9099C70.651 15.5869 70.1718 13.4712 69.9061 11.6114L69.9142 11.6101Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.972 78.0763L91.7281 72.2567L50.9354 114.504L109.535 133.714L144.972 78.0763Z",
    fill: "#43927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7281 72.2552L50.9354 114.503L118.97 136.801L91.7281 72.2552Z",
    fill: "#43927C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.928 123.416C107.928 123.416 113.331 116.041 121.655 116.147C120.61 111.995 119.646 108.731 119.646 108.731C119.646 108.731 113.98 109.236 107.642 115.55C107.814 118.135 107.937 123.423 107.937 123.423L107.928 123.416Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.972 78.0755L109.355 122.391L50.9356 114.503L81.1808 174.935L132.571 180.218L165.512 136.121L144.972 78.0755Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.354 122.391L50.9355 114.503L81.1807 174.935L132.571 180.217L109.354 122.391Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.654 123.148L144.971 78.077L91.4562 71.5228L50.9284 114.514L109.655 123.156L109.654 123.148ZM142.309 79.0797L109.056 121.646L53.7893 113.513L91.9917 72.9932L142.309 79.0797Z",
    fill: "#9CC6BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9742 119.362L107.568 177.641L99.5705 176.824L71.392 117.557L72.544 116.253L85.2412 118.106L83.9742 119.362Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9741 119.362L71.3919 117.557L72.5439 116.253L85.2411 118.106L83.9741 119.362Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.42 160.332L123.96 104.974L122.212 104.842L130.573 94.0133L132.296 94.2484L153.526 152.162L147.42 160.332Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.961 104.976L122.212 104.844L130.573 94.0149L132.296 94.2501L123.961 104.976Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.129 103.437C104.129 103.437 94.2812 96.5926 94.1389 85.6784C88.7282 87.1848 84.4803 88.5674 84.4803 88.5674C84.4803 88.5674 85.3324 95.9816 93.8152 104.089C97.2062 103.782 104.13 103.445 104.13 103.445L104.129 103.437Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.481 47.1649L96.6731 95.6089L33.3498 86.5939L26.8064 75.0262L127.938 35.5972L134.481 47.1649Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.481 47.1649L96.6731 95.6089L90.1298 84.0412L127.938 35.5972L134.481 47.1649Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.938 35.5972L90.1299 84.0412L26.8066 75.0262L70.3133 29.7261L127.938 35.5972Z",
    fill: "#9CC6BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6837 53.3508L64.022 80.3238L69.7958 91.7803L57.1223 89.9737L51.4852 78.5455L91.7139 31.3105L88.6837 53.3508Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.67 32.9207L64.022 80.323L69.7957 91.7794L57.1223 89.9729L51.4852 78.5447L91.7139 31.3097L101.67 32.9207Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.022 80.3233L69.7957 91.7798L57.1222 89.9732L51.4852 78.545L64.022 80.3233Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8863 59.4257L107.289 62.016L114.225 70.2738L118.398 64.4968L114.936 52.2247L55.1081 44.2096L78.8863 59.4257Z",
    fill: "#245B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7799 52.0673L107.289 62.016L114.225 70.2738L118.398 64.4968L114.936 52.2247L55.1081 44.2096L48.7799 52.0673Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.29 62.0154L113.728 73.7566L121.174 64.2197L114.936 52.2241L107.29 62.0154Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.145 24.1464C106.145 24.1464 112.581 36.6154 84.4865 48.9143C56.3934 61.2213 43.2496 58.7855 38.4263 52.0908C36.4726 53.6607 38.5558 58.2125 39.5926 60.2991C40.6293 62.3856 54.9575 70.3402 81.95 59.2963C108.943 48.2523 113.749 39.1195 113.397 32.735C113.052 26.3493 106.145 24.1464 106.145 24.1464Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.709 56.7081C74.709 56.7081 56.4003 45.3908 45.8069 48.6986C35.2135 52.0065 39.5854 60.3092 39.5854 60.3092C39.5854 60.3092 35.3584 52.9345 34.6913 47.1282C34.0242 41.3219 38.8136 37.2673 52.7101 39.2301C66.6147 41.1915 77.6808 47.7378 77.6808 47.7378C77.6808 47.7378 86.0089 29.1851 90.0755 23.4661C94.1421 17.7471 101.585 13.1624 109.828 21.3234C113.12 25.1987 113.38 32.7384 113.38 32.7384C113.38 32.7384 111.632 23.2902 101.074 28.8408C92.7393 33.2177 83.1255 55.3935 83.1255 55.3935L74.7009 56.7094L74.709 56.7081Z",
    fill: "#F4CF19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.6316 56.4025C88.6316 56.4025 79.7559 49.1669 80.7293 41.1618C78.6916 38.8596 69.5887 43.8772 69.9871 44.0465C73.7935 47.2463 73.7932 59.6294 72.3905 62.6094C81.251 62.6556 88.6316 56.4025 88.6316 56.4025Z",
    fill: "#E7B92A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8615 113.707C88.8615 113.707 81.9442 106.414 75.2087 106.953C69.0784 107.398 65.3235 108.497 65.3235 108.497C65.3235 108.497 71.9301 108.879 77.9428 112.974C82.6231 113.83 88.8696 113.706 88.8696 113.706L88.8615 113.707Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3843 99.2441C73.3843 99.2441 61.4455 100.447 54.246 92.2475C51.114 96.9112 48.783 100.722 48.783 100.722C48.783 100.722 54.2459 105.796 65.9698 106.445C68.3419 104.008 73.3856 99.2522 73.3856 99.2522L73.3843 99.2441Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7944 123.657C15.7944 123.657 24.2138 120.085 31.3063 124.425C32.5339 120.323 33.3665 117.027 33.3665 117.027C33.3665 117.027 28.238 114.571 19.567 116.744C18.39 119.052 15.7944 123.657 15.7944 123.657Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.752 105.826C112.752 105.826 113.969 99.0643 119.618 96.38C117.539 93.919 115.807 92.0402 115.807 92.0402C115.807 92.0402 112.152 94.256 109.953 100.609C110.92 102.301 112.752 105.826 112.752 105.826Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.08 82.6189C118.08 82.6189 123.483 75.2445 131.807 75.3497C130.762 71.1979 129.798 67.9344 129.798 67.9344C129.798 67.9344 124.131 68.4392 117.793 74.7527C117.966 77.3379 118.089 82.6257 118.089 82.6257L118.08 82.6189Z",
    fill: "#1CCF9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.612 96.3348C123.612 96.3348 127.051 93.483 131.523 90.0898C132.398 92.2015 133.595 93.9903 134.956 95.5054L129.603 102.624C125.229 99.331 123.613 96.3429 123.613 96.3429L123.612 96.3348Z",
    fill: "#1CCF9E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28544_29783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 176.26,
    fill: "white",
    transform: "matrix(-0.988021 0.154316 0.154316 0.988021 144.251 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.efea630b355d1cc41af5843eba2a95bd.svg";
export { ForwardRef as ReactComponent };